import { Alerta, Button, Card, Logo2M, Stack, TextField } from "@/components";
import type { Usuario } from "@/lib/api";
import { useLoginTab } from "./useLoginTab";

export function LoginTab({ onIngreso }: { onIngreso: (u: Usuario) => void }) {
  const t = useLoginTab(onIngreso);
  return (
    <div className="grid min-h-dvh place-items-center px-4 py-10">
      <div className="w-full max-w-sm">
        <Stack espacio={6}>
          <Stack espacio={4} className="items-center text-center">
            <h1 className="text-carbon">
              <Logo2M className="w-40" />
            </h1>
            <p className="text-texto-suave">Ingresá para ver el avance de la obra</p>
          </Stack>
          <Card>
            <form onSubmit={(e) => void t.enviar(e)} noValidate>
              <Stack espacio={4}>
                <TextField
                  etiqueta="Email"
                  type="email"
                  autoComplete="username"
                  inputMode="email"
                  value={t.email}
                  onChange={(e) => t.setEmail(e.target.value)}
                />
                <TextField
                  etiqueta="Contraseña"
                  type="password"
                  autoComplete="current-password"
                  value={t.password}
                  onChange={(e) => t.setPassword(e.target.value)}
                />
                <Alerta texto={t.error} />
                <Button type="submit" anchoCompleto cargando={t.cargando} disabled={!t.puedeEnviar}>
                  Ingresar
                </Button>
              </Stack>
            </form>
          </Card>
        </Stack>
      </div>
    </div>
  );
}
